import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class AttributesActionsValidator {

    attribute_group_id = [
        Validators.required
    ];

    attr_present_type_id = [
        Validators.required
    ];

    attribute_value_type = [
        Validators.required
    ];
    
    attr_reference_id = [
        Validators.required
    ];


    // Error messages
    errorMessages = {
        attribute_group_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        attr_present_type_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        attribute_value_type: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        attr_reference_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}